// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2h8os","additionalInfo":"AgreementModal_additionalInfo__3ebPS"};